import { MODAL_NEW_GENERATE_PROJECT } from '@components/App/Modal/constants'
import { DASHBOARD_LINK } from '@components/Router/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import { openModal } from '@storeOld/reducers/ui'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { useGenerateProject } from '@/hooks/ai'

export const FetchProject = () => {
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const generateProject = useGenerateProject()

  const { uuid: id } = useParams<{
    uuid: string | undefined
  }>()

  // В deps — примитивы, а не объект auth: он пересоздаётся на каждый
  // auth-экшен (смена команды, прочитанное сообщение) и перезапускал эффект.
  // Смена самого authenticated во время загрузки перезапускает её намеренно:
  // это единственный рефетч для логина, пришедшего раньше ответа проекта
  const { authenticated, setupCompleted } = useAuth()
  const projectId = useSelector(migrationProjectSelector.getProjectId)
  const projectOwner = useSelector(migrationProjectSelector.getProjectOwnerId)

  useEffect(() => {
    // Route param changed while another project is loaded (e.g. router
    // navigation from an open project to a template copy) — load the new one.
    if (id && projectId && id !== projectId) {
      dispatch(managerActions.fetchProjectSaga({ id }))

      return
    }

    if (projectId) {
      if (authenticated && setupCompleted && searchParams.has('save')) {
        if (!projectOwner) {
          dispatch({ type: managerActions.saveProjectSaga.type })
        }

        searchParams.delete('save')
      }

      return
    }

    if (id && !projectId) {
      dispatch(managerActions.fetchProjectSaga({ id }))
    }

    if (!id) {
      if (
        searchParams.has('ai-sitemap') &&
        searchParams.has('new-project') &&
        searchParams.has('generationTheme')
      ) {
        // @ts-expect-error
        generateProject(searchParams.get('generationTheme').trim())

        return
      }

      if (searchParams.has('ai-sitemap')) {
        dispatch({ type: managerActions.createProjectBoilerplateSaga.type })
        dispatch(
          // @ts-expect-error
          openModal(MODAL_NEW_GENERATE_PROJECT, {
            defaultTheme: searchParams.get('generationTheme'),
          })
        )

        return
      }

      if (searchParams.size === 0) {
        if (authenticated) {
          navigate(DASHBOARD_LINK, { replace: true })

          return
        }

        dispatch({ type: managerActions.createProjectBoilerplateSaga.type })
      }
    }
  }, [id, searchParams, projectId, authenticated, setupCompleted])

  return null
}
